import { WatchedFunction } from "component-library";

export const POPUP_SIZE = { lg: 4, md: 6 };

export const TOAST_LIFE_TIME = 6000;

export const MAX_NAME_LENGTH = 249;

export const NEW_SHORT_LIST_OPTION = { value: -1 };

export const SELECTED_SHORTLIST_ID_KEY = "selectedShortlistId";

export interface IShortListForm {
  isNewShortlist: boolean;
  shortlistId?: number;
  shortlistName?: string;
}

export type ShortListFormValidation = {
  [T in keyof Required<Pick<IShortListForm, "shortlistName">>]: {
    invalid: boolean;
    validationMessage: string;
  };
};

export const VALIDATE = new WatchedFunction(() => undefined);

export const GET_VALIDATION_DEFAULT = () => ({
  invalid: false,
  validationMessage: "",
});
